/**
 * Resolves the visible state of the "×N owned" badge.
 *
 * @param {Object} opts
 * @param {number} opts.owned                       Copies of this printing the player owns.
 * @param {number} [opts.maxCopies=4]               Per-deck max for this card's rarity. Used only for playset detection.
 * @param {boolean} [opts.playsetCompleteVariant=true]
 *   When true, flips to the green ✓ variant once owned >= maxCopies. Booster + draft use this default.
 *   The deck editor passes false because the rarity-capacity ornament already shows that signal.
 * @param {boolean} [opts.hideWhenZero=false]
 *   When true and owned === 0, returns null (caller renders nothing). The deck editor uses this to keep
 *   the grid clean for unowned cards (dimmed-card treatment already signals "not owned").
 *
 * @returns {null | { playset: boolean, label: string, title: string }}
 */
export function getOwnedBadgeState({
  owned,
  maxCopies = 4,
  playsetCompleteVariant = true,
  hideWhenZero = false,
}) {
  if (hideWhenZero && owned <= 0) return null;
  const playset = playsetCompleteVariant && owned >= maxCopies;
  return {
    playset,
    label: playset ? `×${owned} ✓` : `×${owned}`,
    title: playset ? `Playset complete (${owned}/${maxCopies} owned)` : `${owned} owned`,
  };
}
